import PropTypes from "prop-types";
import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

const NotificationContainer = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	width: 100%;
	margin: 12px;
	z-index: 12;
`;

const NotificationContent = styled.div`
	display: flex;
    gap: 16px;
    align-items: center;
	width: calc(100% - 24px);
	height: 72px;
	max-width: 400px;
    margin: 0 auto;
    padding: 6px 12px;
	background: ${(props) => props.notificationType === "error" ? "var(--color-error)" : "var(--color-surface-container)"};
    color: ${(props) => props.notificationType === "error" ? "var(--color-on-error)" : "var(--color-on-surface)"};
    border-radius: 6px;
    box-shadow: 0 0 4px var(--color-shadow);
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background: var(--color-surface-container-highest);
        color: var(--color-on-surface);
    }
`;

const IconContainer = styled.div`
    width: 48px;
    height: 48px;
    padding: 6px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

const TextContainer = styled.div``;

export default class InternalNotificationComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowing: false,
            title: props.title,
            text: props.text,
            action: props.action,
        };

        this.show = this.show.bind(this);
    }

    show(props) {
        if (!props.title || !props.text) {
            console.error("NotificationComponent: title and text are required");
            return;
        }

        this.setState({
            isShowing: true,
            ...props,
        });

        const duration = Number.parseInt(localStorage.getItem("pref-int-not-time"), 10) || 5000;

        setTimeout(() => {
            this.setState({
                isShowing: false,
                ...props
            });
        }, duration);
    }

    render() {
        return this.state.isShowing
            ? createPortal(
                <NotificationContainer>
                    <NotificationContent notificationType={this.state.type} onClick={this.state.action}>
                        <IconContainer>
                            <img
                                src="/image/icon-notification.png"
                                alt="Notification Icon"
                            />
                        </IconContainer>
                        <TextContainer>
                            <h4>{this.state.title}</h4>
                            <p>{this.state.text}</p>
                        </TextContainer>
                    </NotificationContent>
                </NotificationContainer>,
                document.body
            )
            : null;
    }
}

InternalNotificationComponent.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.string,
    action: PropTypes.func,
};

InternalNotificationComponent.defaultProps = {
    title: "",
    text: "",
    type: "default",
    action: () => { },
};
